import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import SchemaOrg from '../../components/feature/SchemaOrg';

export default function CasesDetailPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const cases = [
    {
      id: 1,
      title: '新北板橋 3 房家庭搬遷',
      customer: '陳先生',
      location: '新北市板橋區',
      moveType: '家庭搬遷',
      area: '35坪',
      date: '2024年1月',
      rating: 5,
      image: 'https://public.readdy.ai/ai/img_res/07ca19abbf3d4066c74d49b891692abf.jpg',
      description: '陳先生一家四口從板橋舊公寓搬到新大樓，包含大量書籍、家電和家具。我們提供完整的打包、搬運、定位服務，並特別注意鋼琴和古董家具的保護。',
      challenges: [
        '舊家 5 樓無電梯，需要人力搬運',
        '鋼琴重達 250 公斤，需要專業搬運',
        '古董家具需要特殊包裝保護',
        '搬家當天下雨，需要防潮措施'
      ],
      solutions: [
        '安排 4 位專業搬運師傅',
        '使用專業鋼琴搬運設備和保護墊',
        '為古董家具訂製木箱包裝',
        '準備防水布和塑膠套保護物品'
      ],
      result: '順利在 6 小時內完成搬遷，所有物品完好無損，客戶非常滿意我們的專業服務。',
      testimonial: '建鈞搬家的服務真的很專業！從估價到搬家當天，每個環節都很細心。特別是鋼琴搬運，讓我非常放心。師傅們動作俐落又小心，強烈推薦！',
      services: ['專業打包', '鋼琴搬運', '家具拆裝', '定位服務'],
      price: '$12,000'
    },
    {
      id: 2,
      title: '台北信義區辦公室搬遷',
      customer: '王經理',
      location: '台北市信義區',
      moveType: '辦公室搬遷',
      area: '50坪',
      date: '2024年2月',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Modern%20office%20space%20with%20computers%2C%20desks%20and%20office%20equipment%20being%20professionally%20moved%2C%20organized%20business%20relocation%20with%20IT%20equipment%20and%20furniture&width=800&height=600&seq=case002&orientation=landscape',
      description: '科技公司辦公室搬遷，包含大量電腦設備、伺服器、辦公家具和文件檔案。需要在週末完成搬遷，確保週一正常營運。',
      challenges: [
        '伺服器和電腦設備價值高，需要特別小心',
        '機密文件需要安全運送',
        '必須在 48 小時內完成搬遷',
        '新辦公室需要重新規劃配線'
      ],
      solutions: [
        '使用防震包裝材料保護電子設備',
        '提供密封箱和編號系統管理文件',
        '安排 6 位師傅分兩天完成',
        '協助 IT 設備定位和基本配線'
      ],
      result: '週六早上開始搬遷，週日下午完成所有設備定位，週一公司順利開工，客戶高度肯定我們的效率。',
      testimonial: '建鈞搬家團隊非常專業，完全理解我們的需求。搬遷過程井然有序，沒有影響到公司營運。價格合理，服務優質，值得推薦！',
      services: ['IT設備搬運', '文件管理', '家具拆裝', '配線協助'],
      price: '$18,000'
    },
    {
      id: 3,
      title: '新北新莊套房搬遷',
      customer: '林小姐',
      location: '新北市新莊區',
      moveType: '套房搬遷',
      area: '8坪',
      date: '2024年3月',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Cozy%20studio%20apartment%20with%20organized%20personal%20belongings%20and%20moving%20boxes%2C%20compact%20living%20space%20with%20efficient%20packing%20and%20furniture%20arrangement&width=800&height=600&seq=case003&orientation=landscape',
      description: '林小姐是上班族，工作繁忙無暇打包。我們提供全套打包服務，從整理、包裝到搬運、定位一條龍服務。',
      challenges: [
        '客戶工作忙碌，無法協助打包',
        '物品雜亂，需要整理分類',
        '新家電梯狹小，大型家具難進入',
        '預算有限，需要控制成本'
      ],
      solutions: [
        '提供專業打包服務，依類別整理',
        '使用標籤系統，方便後續整理',
        '事前測量，部分家具拆卸後搬運',
        '提供套房搬遷優惠方案'
      ],
      result: '4 小時完成打包和搬遷，林小姐下班後直接入住新家，對我們的效率和細心讚不絕口。',
      testimonial: '真的太感謝建鈞搬家了！我完全沒時間打包，他們幫我整理得井井有條。搬到新家後，每個箱子都有標籤，很容易找到東西。服務超讚！',
      services: ['全套打包', '物品整理', '家具拆裝', '定位服務'],
      price: '$4,500'
    },
    {
      id: 4,
      title: '桃園中壢跨縣市搬家',
      customer: '張先生',
      location: '新北市→桃園市中壢區',
      moveType: '長途搬家',
      area: '30坪',
      date: '2024年3月',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Long%20distance%20moving%20truck%20on%20highway%20with%20professional%20logistics%2C%20cross-city%20relocation%20service%20with%20secure%20cargo%20and%20modern%20transportation&width=800&height=600&seq=case004&orientation=landscape',
      description: '張先生因工作調動，需要從新北市搬到桃園中壢。距離約 40 公里，包含大量家具和家電。',
      challenges: [
        '跨縣市長途搬運，路程較遠',
        '需要協調兩地的時間和停車',
        '大型家具需要保護，避免碰撞',
        '客戶希望一天內完成'
      ],
      solutions: [
        '使用大型貨車，減少往返次數',
        '提前申請兩地停車位',
        '使用厚棉被和保護墊包裹家具',
        '早上 7 點開始，下午 5 點完成'
      ],
      result: '順利在 10 小時內完成跨縣市搬遷，所有物品安全送達，客戶對我們的效率和專業非常滿意。',
      testimonial: '跨縣市搬家本來很擔心，但建鈞搬家處理得很好。師傅們很有經驗，知道怎麼保護家具。價格也很合理，比其他家便宜又專業！',
      services: ['長途搬運', '家具保護', '兩地協調', '快速搬遷'],
      price: '$15,000'
    },
    {
      id: 5,
      title: '台北大安區精緻搬家',
      customer: '李太太',
      location: '台北市大安區',
      moveType: '精緻搬家',
      area: '45坪',
      date: '2024年4月',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Luxury%20apartment%20interior%20with%20high-end%20furniture%20and%20delicate%20items%2C%20premium%20moving%20service%20with%20careful%20handling%20of%20valuable%20belongings&width=800&height=600&seq=case005&orientation=landscape',
      description: '李太太家中有許多名貴家具、藝術品和古董，需要最高規格的搬家服務。我們提供白手套級的精緻搬家服務。',
      challenges: [
        '名貴家具和藝術品價值極高',
        '古董瓷器易碎，需要特殊包裝',
        '客戶要求最高標準的服務',
        '新家裝潢剛完成，不能有任何損傷'
      ],
      solutions: [
        '使用專業藝術品包裝材料',
        '為每件貴重物品拍照存證',
        '安排最資深的搬運團隊',
        '全程使用保護墊和防撞材料'
      ],
      result: '完美完成搬遷，所有物品完好無損，新家裝潢也沒有任何刮傷。李太太非常滿意，還介紹朋友使用我們的服務。',
      testimonial: '建鈞搬家的精緻搬家服務真的名不虛傳！師傅們非常細心，對待每件物品都像對待自己的東西一樣小心。雖然價格較高，但物超所值！',
      services: ['精緻包裝', '藝術品搬運', '全程保險', '白手套服務'],
      price: '$25,000'
    },
    {
      id: 6,
      title: '新北三重廢棄物清運',
      customer: '黃先生',
      location: '新北市三重區',
      moveType: '廢棄物清運',
      area: '20坪',
      date: '2024年4月',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Waste%20disposal%20and%20junk%20removal%20service%20with%20organized%20sorting%20and%20eco-friendly%20recycling%2C%20professional%20cleanup%20with%20proper%20waste%20management&width=800&height=600&seq=case006&orientation=landscape',
      description: '黃先生的父母過世後，需要清理老家的大量雜物和廢棄物。我們提供完整的清運和分類服務。',
      challenges: [
        '物品堆積多年，雜亂無章',
        '需要分類可回收和不可回收物品',
        '部分大型家具需要拆除',
        '客戶情感上難以割捨'
      ],
      solutions: [
        '耐心協助客戶整理和決定',
        '專業分類，環保處理',
        '提供拆除和清運一條龍服務',
        '可回收物品協助捐贈'
      ],
      result: '用了兩天時間完成清理，老家煥然一新。黃先生很感謝我們的耐心和專業，讓他能好好告別過去。',
      testimonial: '清理父母的老家對我來說很不容易，建鈞搬家的師傅們很有同理心，不會催促我。他們還幫我把一些還能用的東西捐給慈善機構，很有愛心！',
      services: ['廢棄物清運', '物品分類', '家具拆除', '環保處理'],
      price: '$8,000'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <SchemaOrg type="website" />

      {/* Hero Section */}
      <section className="relative py-12 md:py-16 bg-gradient-to-r from-teal-600 to-emerald-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
            <strong>客戶搬家案例分享</strong>
          </h1>
          <p className="text-lg md:text-xl text-teal-100 mb-6">
            真實客戶見證，<strong className="text-white">5000+ 成功搬家案例</strong>
          </p>
          <div className="flex items-center justify-center gap-2 text-white/90">
            <i className="ri-star-fill text-yellow-300 text-2xl"></i>
            <span>平均評分 4.8 分 · 156 則客戶好評</span>
          </div>
        </div>
      </section>

      {/* Cases Grid */}
      <section className="py-12 md:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-16">
            {cases.map((caseItem, index) => (
              <div key={caseItem.id} className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
                <div className="grid lg:grid-cols-2 gap-0">
                  {/* 圖片 */}
                  <div className={`h-64 lg:h-auto ${index % 2 === 0 ? 'lg:order-1' : 'lg:order-2'}`}>
                    <img
                      src={caseItem.image}
                      alt={caseItem.title}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>

                  {/* 內容 */}
                  <div className={`p-6 md:p-8 lg:p-10 ${index % 2 === 0 ? 'lg:order-2' : 'lg:order-1'}`}>
                    {/* 標題和基本資訊 */}
                    <div className="mb-6">
                      <div className="flex items-center gap-2 mb-3">
                        <span className="bg-teal-100 text-teal-600 px-3 py-1 rounded-full text-sm font-semibold">
                          {caseItem.moveType}
                        </span>
                        <span className="text-gray-500 text-sm">{caseItem.date}</span>
                      </div>
                      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
                        {caseItem.title}
                      </h2>
                      <div className="flex items-center gap-1 mb-4">
                        {[...Array(caseItem.rating)].map((_, i) => (
                          <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                        ))}
                        <span className="ml-2 text-gray-600 font-semibold">{caseItem.rating}.0</span>
                      </div>
                      <div className="grid grid-cols-2 gap-4 text-sm">
                        <div>
                          <span className="text-gray-500">客戶：</span>
                          <span className="font-semibold text-gray-900">{caseItem.customer}</span>
                        </div>
                        <div>
                          <span className="text-gray-500">地點：</span>
                          <span className="font-semibold text-gray-900">{caseItem.location}</span>
                        </div>
                        <div>
                          <span className="text-gray-500">坪數：</span>
                          <span className="font-semibold text-gray-900">{caseItem.area}</span>
                        </div>
                        <div>
                          <span className="text-gray-500">費用：</span>
                          <span className="font-semibold text-teal-600">{caseItem.price}</span>
                        </div>
                      </div>
                    </div>

                    {/* 描述 */}
                    <p className="text-gray-700 leading-relaxed mb-6">
                      {caseItem.description}
                    </p>

                    {/* 服務項目 */}
                    <div className="mb-6">
                      <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <i className="ri-service-line text-teal-600"></i>
                        提供服務
                      </h4>
                      <div className="flex flex-wrap gap-2">
                        {caseItem.services.map((service, i) => (
                          <span key={i} className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-sm">
                            {service}
                          </span>
                        ))}
                      </div>
                    </div>

                    {/* 客戶評價 */}
                    <div className="bg-gradient-to-br from-teal-50 to-emerald-50 rounded-xl p-6 border-l-4 border-teal-500">
                      <div className="flex items-center gap-3 mb-3">
                        <div className="bg-teal-600 w-10 h-10 rounded-full flex items-center justify-center">
                          <i className="ri-user-line text-white text-xl"></i>
                        </div>
                        <div>
                          <div className="font-bold text-gray-900">{caseItem.customer}</div>
                          <div className="text-sm text-gray-600">客戶評價</div>
                        </div>
                      </div>
                      <p className="text-gray-700 italic leading-relaxed">
                        「{caseItem.testimonial}」
                      </p>
                    </div>
                  </div>
                </div>

                {/* 展開詳情（挑戰與解決方案） */}
                <div className="bg-gray-50 p-6 md:p-8 lg:p-10 border-t border-gray-200">
                  <div className="grid md:grid-cols-2 gap-8">
                    <div>
                      <h4 className="font-bold text-gray-900 mb-4 flex items-center gap-2 text-lg">
                        <i className="ri-alert-line text-orange-600"></i>
                        搬家挑戰
                      </h4>
                      <ul className="space-y-3">
                        {caseItem.challenges.map((challenge, i) => (
                          <li key={i} className="flex items-start gap-3 text-gray-700">
                            <i className="ri-close-circle-fill text-orange-500 mt-1 flex-shrink-0"></i>
                            <span>{challenge}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-4 flex items-center gap-2 text-lg">
                        <i className="ri-lightbulb-line text-teal-600"></i>
                        解決方案
                      </h4>
                      <ul className="space-y-3">
                        {caseItem.solutions.map((solution, i) => (
                          <li key={i} className="flex items-start gap-3 text-gray-700">
                            <i className="ri-checkbox-circle-fill text-teal-500 mt-1 flex-shrink-0"></i>
                            <span>{solution}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className="mt-6 pt-6 border-t border-gray-200">
                    <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                      <i className="ri-trophy-line text-teal-600"></i>
                      搬家成果
                    </h4>
                    <p className="text-gray-700 leading-relaxed">{caseItem.result}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-12 md:py-20 bg-gradient-to-br from-teal-600 to-emerald-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-white mb-4">客戶滿意度統計</h2>
            <p className="text-lg text-teal-100">數據說話，品質保證</p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">5000+</div>
              <div className="text-teal-100">成功案例</div>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">4.8</div>
              <div className="text-teal-100">平均評分</div>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">98%</div>
              <div className="text-teal-100">客戶滿意度</div>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">10年</div>
              <div className="text-teal-100">專業經驗</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-12 md:py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">讓我們為您服務</h2>
          <p className="text-lg text-gray-600 mb-8">
            加入 5000+ 滿意客戶的行列，體驗專業搬家服務
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://line.me/ti/p/@285yavdh"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-green-600 text-white px-8 py-4 rounded-full text-lg font-bold hover:bg-green-700 transition-all cursor-pointer shadow-lg hover:shadow-2xl whitespace-nowrap"
            >
              <img 
                src="https://static.readdy.ai/image/9ef47c451bf9aafd7a63eea67af7d95d/c33a3c3f2fa31df7dfad05bfabc09369.webp" 
                alt="LINE" 
                className="w-6 h-6"
                loading="lazy"
              />
              <span>LINE 免費諮詢</span>
            </a>
            <a
              href="tel:0978900081"
              className="inline-flex items-center justify-center gap-2 bg-teal-600 text-white px-8 py-4 rounded-full text-lg font-bold hover:bg-teal-700 transition-all cursor-pointer shadow-lg hover:shadow-2xl whitespace-nowrap"
            >
              <i className="ri-phone-line text-xl"></i>
              <span>立即來電</span>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
